import * as React from 'react';

const PixelHeart: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 51 44" {...props}>
    <g fill="none">
      <path
        fill="#FF52A0"
        d="M47.672 6.837v-3.37h-3.326V.097H31.042v3.37h-3.326v3.37h-4.434v-3.37h-3.326V.097H6.652v3.37H3.326v3.37H0v20.217h3.326v3.37h3.326v3.37h3.326v3.37h6.652v3.369h6.652v3.37h4.434v-3.37h6.652v-3.37h6.652v-3.37h3.326v-3.369h3.326v-3.368H51V6.838z"
      />
      <path
        fill="#FFF"
        d="M31.042.098v3.37h-3.326v3.369h-4.434v3.37h7.76v-3.37h3.326V.097zM6.652 3.467H3.326v3.37H0v3.37h6.652v-3.37h3.326V.097H6.652z"
      />
      <path
        fill="#0F30A3"
        d="M3.326 3.467h3.326v3.37H3.326zm41.019 0h3.326v3.37h-3.326zm-16.629 0h3.326v3.37h-3.326zM3.326 27.054h3.326v3.37H3.326zm41.019 0h3.326v3.37h-3.326zM16.63 37.163h6.652v3.37H16.63zm11.086 0h6.652v3.37h-6.652zM19.955 3.467h3.326v3.37h-3.326zm3.326 3.37h4.435v3.37h-4.435zm11.087 26.956h6.652v3.37h-6.652zm-24.39 0h6.652v3.37H9.978zm-3.326-3.369h3.326v3.37H6.652zm34.368 0h3.326v3.37H41.02zM23.281 40.533h4.435v3.37h-4.435z"
      />
      <path
        fill="#0F30A3"
        d="M6.652.098h13.304v3.37H6.652zm24.39 0h13.304v3.37H31.042zM0 6.837h3.326v20.217H0zm47.671 0h3.326v20.217h-3.326z"
      />
    </g>
  </svg>
);

export default PixelHeart;
